import React from 'react';

import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import TuneIcon from '@mui/icons-material/Tune';

import { AdminContext } from './AdminContext';

/**
 * Floating button that opens/closes the Configurator Admin panel.
 *
 * M0 stub: it only toggles `panelOpen` in AdminContext. The actual admin panel (EA-437) and its
 * contents (EA-439…EA-447) are wired up in later milestones. Rendered only when `isAdmin`.
 */
const AdminModeToggle: React.FC = () => {
    const admin = React.useContext(AdminContext);

    if (!admin.isAdmin) {
        return null;
    }

    return (
        <Tooltip title={admin.panelOpen ? 'Admin panel bezárása' : 'Admin panel megnyitása'} placement="left">
            <Fab
                color={admin.panelOpen ? 'primary' : 'default'}
                size="medium"
                aria-label="configurator-admin"
                onClick={() => admin.setPanelOpen(!admin.panelOpen)}
                sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1300 }}
            >
                <TuneIcon />
            </Fab>
        </Tooltip>
    );
};

export default AdminModeToggle;
